module.exports = __webpack_public_path__ + "img/56-image-1@2x.701bb819.png";